// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"183":"3af16163","451":"13695d69","793":"ef1bc2b6","916":"c784a4a5"}[chunkId] + ".chunk.css";
};